<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { HOME_TOUR_STEPS } from '@features/feature-tour'
import { FeatureTourSpot } from '@features/feature-tour'

import { useBtnMore } from './btn-more.hook'
import HeaderNavItem from './HeaderNavItem.vue'
import DropdownMore from './DropdownMore.vue'

defineOptions({
  name: 'BtnMore',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const route = useRoute()

const {
  disabled,
  selected,
  isNew,
  pointer,
} = useBtnMore({ route })
</script>

<template>
  <FeatureTourSpot :id="HOME_TOUR_STEPS.BTN_MORE">
    <HeaderNavItem
      :layout="layout"
      icon="circle-ellipsis"
      label="More"
      :selected="selected"
      :disabled="disabled"
      :indicator="isNew ? { view: 'new' } : undefined"
      :pointer="pointer && !isNew"
    >
      <template #menu>
        <DropdownMore />
      </template>
    </HeaderNavItem>
  </FeatureTourSpot>
</template>
